'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

function onRecaptchaSuccess(token) {
    document.getElementById('g-recaptcha-response').value = token; // Almacenar token generado
}

function onRecaptchaExpired() {
    document.getElementById('g-recaptcha-response').value = ''; // Limpiar el token cuando expire
}

module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
        
            // Obtener respuesta de reCAPTCHA desde Google
            var recaptchaResponse = grecaptcha.getResponse();
            if (!recaptchaResponse) {
                if (!$('.recaptcha-error').length) {
                    $('.g-recaptcha').after('<div class="recaptcha-error text-danger">Por favor, completa el reCAPTCHA.</div>');
                }
                return;
            }
            $('.recaptcha-error').remove();
            
            // csrf_token
            var customerConnectTkDiv = $('#customerConnectTk');
            var csrfTokenValue = customerConnectTkDiv.find('input[name="csrf_token"]').val();
            if (!csrfTokenValue) {
                return
            }
            var csrfTokenInput = $('#csrf-token');
            csrfTokenInput.val(csrfTokenValue);
            
            // Val subscribed
            var subscribedVerif = $('#subscribed-field').val();
            if (subscribedVerif) {
                return;
            }
            
            // Comment textArea
            var commentTextArea = $('#contact-comment').val().trim(); // Elimina espacios al inicio y final
            if (commentTextArea.length < 10) {
                if (!$('.comment-error').length) {
                    $('#contact-comment').after('<div class="comment-error text-danger">El comentario debe tener al menos 10 caracteres.</div>');
                }
                return;
            }
            $('.comment-error').remove();
        
            var form = $(this);
    var button = $('.subscribe-contact-us');
    var url = form.attr('action');

    $.spinner().start();
    button.attr('disabled', true);

    // Enviar formulario con la respuesta de reCAPTCHA al backend
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize() + '&g-recaptcha-response=' + recaptchaResponse,
        success: function (data) {
            displayMessage(data, button);
            if (data.success) {
                $('.contact-us').trigger('reset');
                grecaptcha.reset(); // Resetear reCAPTCHA tras enviar el formulario
            }
        },
        error: function (err) {
            displayMessage(err, button);
        }
    });
});
    },
    validateFormEmail: function() {
        $('#contact-email').change(function() {
            if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test($('#contact-email').val()) === false) {
                $('#contact-email').addClass('invalidEmail');
                $('.validation-email-error').removeClass('d-none');
            } else {
                $('#contact-email').removeClass('invalidEmail');
                $('.validation-email-error').addClass('d-none');
            }
        });
    }
};
